export type AirportKey =
  | 'europe'
  | 'tegel'
  | 'tempelhof'
  | 'berlinBradenburg'
  | 'schoenefeld'
  | 'berlinTop';

export interface AirportLocationProps<Key extends AirportKey = AirportKey> {
  key: Key;
  latitude: number;
  longitude: number;
  zoom?: number;
  minZoom?: number;
  maxZoom?: number;
  pitch: number;
  bearing: number;
  altitude?: number;
  radius?: number;
  isPhysicalAirport?: boolean;
}

const minZoom = 4;

export const europe: AirportLocationProps<'europe'> = {
  key: 'europe',
  latitude: 47.65,
  longitude: 7,
  zoom: 4.8,
  minZoom,
  pitch: 50,
  bearing: 0,
  isPhysicalAirport: false,
};

export const berlinTop: AirportLocationProps<'berlinTop'> = {
  key: 'berlinTop',
  latitude: 52.520008,
  longitude: 13.404954,
  zoom: 9,
  minZoom,
  pitch: 0,
  bearing: 0,
  isPhysicalAirport: false,
};

export const tempelhof: AirportLocationProps<'tempelhof'> = {
  key: 'tempelhof',
  longitude: 13.401893,
  latitude: 52.475391,
  pitch: 45,
  bearing: 0,
  zoom: 13,
  minZoom,
  isPhysicalAirport: true,
};

export const tegel: AirportLocationProps<'tegel'> = {
  key: 'tegel',
  longitude: 13.288437,
  latitude: 52.558833,
  pitch: 45,
  bearing: 0,
  zoom: 13,
  minZoom,
  isPhysicalAirport: true,
};

export const schoenefeld: AirportLocationProps<'schoenefeld'> = {
  key: 'schoenefeld',
  longitude: 13.5170006,
  latitude: 52.3923169,
  pitch: 60,
  bearing: 0,
  zoom: 12,
  minZoom,
  isPhysicalAirport: true,
};

export const berlinBradenburg: AirportLocationProps<'berlinBradenburg'> = {
  key: 'berlinBradenburg',
  longitude: 13.5158929,
  latitude: 52.3651346,
  pitch: 60,
  bearing: 0,
  zoom: 15,
  minZoom,
  isPhysicalAirport: true,
};
